import AxiosFunctions from './axiosFunctions'

const uri = {
    getRolesUri: '/seguridad/roles',
    getPermisosUri: '/seguridad/permisos',
    savePermisosUri: '/seguridad/permisos/asignar-desasignar'
}

export default {
    getRoles: async () => {
        return await AxiosFunctions.get(uri.getRolesUri);
    },

    saveRoles: async (data) => {
        return await AxiosFunctions.post(uri.getRolesUri, data);
    },

    editRoles: async (data) => {
        let id = data[0];
        let params = { name: data[1], guard_name: data[2] }
        return await AxiosFunctions.patch(uri.getRolesUri + '/' + id, params);
    },

    deleteRoles: async (id) => {
        return await AxiosFunctions.delete(uri.getRolesUri + '/' + id, {});
    },

    getPermisos: async (id) => {
        return await AxiosFunctions.get(uri.getPermisosUri + "/" + id);
    },

    savePermisos: async (data) => {
        return await AxiosFunctions.post(uri.savePermisosUri, data);
    },

}